export type SovWeight = 'count' | 'fold_weight' | 'rank_weight'

export const NON_WEIGHTED = 'count'
export const FOLD_AND_AREA_WEIGHTED = 'fold_weight'
export const POSITION_WEIGHTED = 'rank_weight'
